import { Injectable } from "@angular/core";
import { Http, Response, Headers, Jsonp, RequestOptions } from "@angular/http";
import "rxjs/add/operator/map";
import { environment } from "../../environments/environment";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { HttpClient } from "../../ajax/http-client.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { DecryptPipe } from "../auth/_services/encrypt-decrypt.pipe";

@Injectable()
export class appService {
  isBestUrl: any =
    environment.apiUrl == "https://best.ifreightbox.net/" ? true : false;
  private showMap: boolean = false;
  constructor(
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private _router: Router,
    private decryptpipe: DecryptPipe,
    private anghttp: Http
  ) {
    this.http = httpClient;
    //added by vithujan 01-11-2022
    var userId = null;
    if (this.cookieService.get("UserId")) {
      userId = this.decryptpipe.transform(
        JSON.parse(this.cookieService.get("UserId"))
      );
    } else {
      userId = null;
    }
    this.CheckSysToken(userId);
    if (this.isBestUrl) this._router.navigateByUrl("/VehicleTracking");
    //end
  }

  http: HttpClient;
  private _refreshNeeded$ = new Subject<void>();
  private documentListSubject = new BehaviorSubject<any[]>([]);
  documentList$ = this.documentListSubject.asObservable();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  setShowMap(value: boolean) {
    this.showMap = value;
  }

  getShowMap(): boolean {
    return this.showMap;
  }

  GetDriverLoc(ControllerName: any, ActionName: any, orderno: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?orderno=" +
      orderno;
    return this.http.get(url).map((response: Response) => response.json());
  }

  Get(ControllerName: any, ActionName: any) {
    let url = environment.apiUrl + "api/" + ControllerName + "/" + ActionName;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetById(ControllerName: any, ActionName: any, Id: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/" +
      Id;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByTenantId(
    ControllerName: any,
    ActionName: any,
    Id: any,
    searchValue: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?TenantId=" +
      Id +
      "&SearchValue=" +
      searchValue;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetMatchGST(
    ControllerName: any,
    ActionName: any,
    stateName: any,
    gstCode: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?stateName=" +
      stateName +
      "&gstCode=" +
      gstCode;
    return this.http.get(url).map((response: Response) => response.json());
  }

  PostBagNumbering(
    ControllerName: any,
    ActionName: any,
    Prefix: any,
    Suffix: any,
    StartNumber: any,
    isZeroPaddingFlag: any,
    NoDigits: any,
    EndNumber: any,
    CompanyId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?Prefix=" +
      Prefix +
      "&Suffix=" +
      Suffix +
      "&StartNumber=" +
      StartNumber +
      "&isZeroPaddingFlag=" +
      isZeroPaddingFlag +
      "&NoDigits=" +
      NoDigits +
      "&EndNumber=" +
      EndNumber +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetBagNumbers(ControllerName: any, ActionName: any, CompanyId: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetByTenantIdParam2(
    ControllerName: any,
    ActionName: any,
    Id: any,
    searchValue: any,
    CompanyType,
    ActiveStatus
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?TenantId=" +
      Id +
      "&SearchValue=" +
      searchValue +
      "&CompanyType=" +
      CompanyType +
      "&ActiveStatus=" +
      ActiveStatus;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByCompanyIdTenantId(
    ControllerName: any,
    ActionName: any,
    TenantId: any,
    CompanyId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?TenantId=" +
      TenantId +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by maaria on 22-09-2023
  GetTaxIdByType(ControllerName: any, ActionName: any, Type: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?Type=" +
      Type;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByDriver(ControllerName: any, ActionName: any, MobileNo: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?MobileNo=" +
      MobileNo;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetbyOneId(ControllerName: any, ActionName: any, orderno: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?orderno=" +
      orderno;
    return this.http.get(url).map((response: Response) => response.json());
  }
  // manoj service 10/03/2022
  sendUpdateInvoiceId(
    ControllerName: any,
    ActionName: any,
    InvoicechangId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/InvoicechangId=" +
      InvoicechangId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  Getbyuserid(ControllerName: any, ActionName: any, userid: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?userid=" +
      userid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetbyNetwork(ControllerName: any, ActionName: any, networkid: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?networkid=" +
      networkid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  Getbyorderid(ControllerName: any, ActionName: any, orderid: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?orderid=" +
      orderid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetOrderIdByOrdeNo(ControllerName: any, ActionName: any, OrderNo: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?OrderNo=" +
      OrderNo;
    return this.http.get(url).map((response: Response) => response.json());
  }

  Getbyorderid1(ControllerName: any, ActionName: any, orderid: any, id: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?orderid=" +
      orderid +
      "&id=" +
      id;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetUserbyType(ControllerName: any, ActionName: any, UserId: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?UserId=" +
      UserId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  ChangeSmsService(ControllerName: any, ActionName: any, value: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?value=" +
      value;
    return this.http.get(url).map((response: Response) => response.json());
  }

  changeHubAndSpokeService(ControllerName: any, ActionName: any, value: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?value=" +
      value;
    return this.http.get(url).map((response: Response) => response.json());
  }

  ChangeTaxService(ControllerName: any, ActionName: any, value: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?value=" +
      value;
    return this.http.get(url).map((response: Response) => response.json());
  }

  ChangeWhiteLabelervice(ControllerName: any, ActionName: any, value: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?value=" +
      value;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetUserType(ControllerName: any, ActionName: any, UserId: any, type: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?UserId=" +
      UserId +
      "&type=" +
      type;
    return this.http.get(url).map((response: Response) => response.json());
  }

  UpdateDriverMobileSetting(
    ControllerName: any,
    ActionName: any,
    value: any,
    settingname: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?value=" +
      value +
      "&settingname=" +
      settingname;
    return this.http.get(url).map((response: Response) => response.json());
  }

  setDefaultLang(ControllerName: any, ActionName: any, lang: any, userid: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?lang=" +
      lang +
      "&userid=" +
      userid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  Getbyuseridtype(
    ControllerName: any,
    ActionName: any,
    userid: any,
    type: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?userid=" +
      userid +
      "&type=" +
      type;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQuery(ControllerName: any, ActionName: any, Query: any) {
    // var headers = new Headers();
    // let user_access_token = this.decryptpipe.transform(
    //   JSON.parse(this.cookieService.get("user_access_token"))
    // );
    // const token: string = "Bearer " + user_access_token;
    // headers.append("Authorization", token);
    // let options = new RequestOptions({ headers: headers });
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      Query;
    return this.http.get(url).map((response: Response) => response.json());
  }
  
  GetByOneParam(ControllerName: any, ActionName: any, param1: any) {
    // var headers = new Headers();
    // let user_access_token = this.decryptpipe.transform(
    //   JSON.parse(this.cookieService.get("user_access_token"))
    // );
    // const token: string = "Bearer " + user_access_token;
    // headers.append("Authorization", token);
    // let options = new RequestOptions({ headers: headers });
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param1=" +
      param1;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByTwoId(ControllerName: any, ActionName: any, Id: any, param1: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Id +
      "&param1=" +
      param1;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByIdparam(ControllerName: any, ActionName: any, Id: any, param1: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?Id=" +
      Id +
      "&param1=" +
      param1;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetInterOrIntra(
    ControllerName: any,
    ActionName: any,
    VendorStateName: any,
    TenantId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?VendorStateName=" +
      VendorStateName +
      "&TenantId=" +
      TenantId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetGSTIfApplicable(
    ControllerName: any,
    ActionName: any,
    isIntra: any,
    chargeId: any,
    VendorId: any,
    TenantId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?isIntra=" +
      isIntra +
      "&chargeId=" +
      chargeId +
      "&VendorId=" +
      VendorId +
      "&TenantId=" +
      TenantId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPage(ControllerName: any, ActionName: any, query: any, page: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByTenantWithGetTypeByTwoId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TranspoterId,
    Type: any,
    GetType: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TranspoterId=" +
      TranspoterId +
      "&Type=" +
      Type +
      "&GetType=" +
      GetType;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageTransGSTCharge(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    ChargeType: any,
    GSTType: any,
    TranspoterId: any,
    THCId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&ChargeType=" +
      ChargeType +
      "&GSTType=" +
      GSTType +
      "&TranspoterId=" +
      TranspoterId +
      "&THCId=" +
      THCId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageCategoryNameParentId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    categoryName,
    parentId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CategoryName=" +
      categoryName +
      "&ParentId=" +
      parentId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByFourId_GetNetworkDataByOwnership(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TenantId,
    OwnershipType
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TenantId=" +
      TenantId +
      "&OwnershipType=" +
      OwnershipType;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByParamPage(ControllerName: any, ActionName: any, param: any, page: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&page=" +
      page;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByCompanyId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    userCompanyId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&userCompanyId=" +
      userCompanyId +
      "&page=" +
      page;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetReadytodispatchListLR(
    ControllerName: any,
    ActionName: any,
    CompanyId: any,
    fcnumber: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?CompanyId=" +
      CompanyId +
      "&fcnumber=" +
      fcnumber;
    return this.http.get(url).map((response: Response) => response.json());
  }

  SaveandUploadLR(ControllerName: any, ActionName: any, body: any) {
    return this.http.post(
      `${environment.apiUrl}/api/${ControllerName}/${ActionName}`,
      body
    );
  }

  GetByThreeId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByFourId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetByFiveId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetBySixId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetBySevenId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByEightId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any,
    param7: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6 +
      "&param7=" +
      param7;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetByNineId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any,
    param7: any,
    param8: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6 +
      "&param7=" +
      param7 +
      "&param8=" +
      param8;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetByTenId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any,
    param7: any,
    param8: any,
    param9: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6 +
      "&param7=" +
      param7 +
      "&param8=" +
      param8 +
      "&param9=" +
      param9;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetByElevenId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any,
    param7: any,
    param8: any,
    param9: any,
    param10: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6 +
      "&param7=" +
      param7 +
      "&param8=" +
      param8 +
      "&param9=" +
      param9 +
      "&param10=" +
      param10;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByTwelveId(
    ControllerName: any,
    ActionName: any,
    param: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any,
    param5: any,
    param6: any,
    param7: any,
    param8: any,
    param9: any,
    param10: any,
    param11: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param=" +
      param +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4 +
      "&param5=" +
      param5 +
      "&param6=" +
      param6 +
      "&param7=" +
      param7 +
      "&param8=" +
      param8 +
      "&param9=" +
      param9 +
      "&param10=" +
      param10 +
      "&param11=" +
      param11;
    return this.http.get(url).map((response: Response) => response.json());
  }

  getDocumentList(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + "api/Document/GetDocumentList";
    return this.http.post(apiUrl, params); // Call API and return observable
  }

  Post(ControllerName: any, ActionName: any, Data: any) {
    return this.http
      .post(
        environment.apiUrl + "api/" + ControllerName + "/" + ActionName,
        Data
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  PostFunc(ControllerName: any, ActionName: any, Data: any) {
    return this.http
      .post(
        environment.apiUrl + "api/" + ControllerName + "/" + ActionName,
        Data
      )
      .pipe();
  }

  PostByUserIdAndCompanyId(
    ControllerName: any,
    ActionName: any,
    Data: any,
    userId,
    CompanyId
  ) {
    return this.http
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?UserId=" +
        userId +
        "&CompanyId=" +
        CompanyId,
        Data
      )
      .pipe();
  }

  File(ControllerName: any, ActionName: any, Data: any, Options: any) {
    return this.http
      .file(
        environment.apiUrl + "api/" + ControllerName + "/" + ActionName,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  FileByCategoryId(
    ControllerName: any,
    ActionName: any,
    upload_data,
    Data: any,
    Options: any
  ) {
    return this.anghttp
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?CategoryId=" +
        upload_data.LookupCategoryID +
        "&isProduct=" +
        upload_data.isProduct,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }


  FileByCompanyIdAndUserId(
    ControllerName: any,
    ActionName: any,
    userId,
    CompanyId,
    Data: any,
    Options: any
  ) {
    return this.anghttp
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?UserId=" +
        userId +
        "&CompanyId=" +
        CompanyId,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  FileByCompanyId(
    ControllerName: any,
    ActionName: any,
    CompanyId,
    Data: any,
    Options: any
  ) {
    return this.anghttp
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?CompanyId=" +
        CompanyId,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  getDataBy(ControllerName: any, ActionName: any, Data: any, Options: any) {
    return this.http
      .file(
        environment.apiUrl + "api/" + ControllerName + "/" + ActionName,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  Delete(ControllerName: any, ActionName: any, Id: any) {
    return this.http.post(
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/" +
      Id,
      ""
    );
  }

  CancleDeleteOrder(
    ControllerName: any,
    ActionName: any,
    Id: any,
    userid: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?Id=" +
      Id +
      "&userid=" +
      userid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  PostTwo(ControllerName: any, ActionName: any, Data: any, Param: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Data +
      "&Param=" +
      Param;
    return this.http.get(url).map((response: Response) => response.json());
  }
  PostOrderId(ControllerName: any, ActionName: any, Data: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?OrderId=" +
      Data;
    return this.http.get(url).map((response: Response) => response.json());
  }

  PostOrderNo(ControllerName: any, ActionName: any, Data: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?OrderNo=" +
      Data;
    return this.http.get(url).map((response: Response) => response.json());
  }

  DeleteTwo(ControllerName: any, ActionName: any, Id: any, Param: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Id +
      "&Param=" +
      Param;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetListById(ControllerName: any, ActionName: any, Id: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/" +
      Id;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetListByIds(
    ControllerName: any,
    ActionName: any,
    Id: any,
    param1: any,
    param2: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Id +
      "&param1=" +
      param1 +
      "&param2=" +
      param2;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetListByFourParameters(
    ControllerName: any,
    ActionName: any,
    Id: any,
    param1: any,
    param2: any,
    param3: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Id +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetListByFiveParameters(
    ControllerName: any,
    ActionName: any,
    Id: any,
    param1: any,
    param2: any,
    param3: any,
    param4: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?id=" +
      Id +
      "&param1=" +
      param1 +
      "&param2=" +
      param2 +
      "&param3=" +
      param3 +
      "&param4=" +
      param4;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //add by maaria on 17-11-2023

  GetParentAccounts(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page;
    return this.http.get(url).map((response: Response) => response.json());
  }
  // add trupti 14-dec-2021
  GetbyFormId(ControllerName: any, ActionName: any, FormId: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?FormId=" +
      FormId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by vithujan 01-11-2022
  CheckSysToken(userId: any) {
    this.GetById("User", "CheckSysToken", userId).subscribe(
      (data) => {
        // alert(data[0].Status);
        if (data[0].Status == false) {
          // remove user from local storage to log user out
          localStorage.removeItem("rights_assigned");
          localStorage.removeItem("user_Type_Rights");
          this.cookieService.delete("User");
          // this._router.navigateByUrl("/login");
        }
      },
      (err) => {
        console.log("errerr", err);
      }
    );
  }
  //end

  PostwithTId(ControllerName: any, ActionName: any, Data: any, id: any) {
    const url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/" +
      id;

    return this.http
      .post(url, { data: Data, id: id }) // Modify the structure of the request body as needed
      .map((response: Response) => {
        return response.text() !== "" ? response.json() : null;
      });
  }

  //added by vithujan 02-12-2023 - Siddarth
  GetByTwoParam(
    ControllerName: any,
    ActionName: any,
    param1: any,
    param2: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?param1=" +
      param1 +
      "&param2=" +
      param2;
    return this.http.get(url).map((response: Response) => response.json());
  }

  // added for signup documents
  getDocumentsListToUpload = (countryName: string): Observable<any> => {
    return this.GetById("Signup", "GetDocumentsListToUpload", countryName);
  };

  Deleteuombyid(ControllerName: any, ActionName: any, Id: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?Id=" +
      Id;
    return this.http.get(url).map((response: Response) => response.json());
  }
  GetbyCompanyId(ControllerName: any, ActionName: any, companyid: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "/?companyid=" +
      companyid;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryCompanyId(
    ControllerName: any,
    ActionName: any,
    query: any,
    CompanyId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByTenantId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TenantId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TenantId=" +
      TenantId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageCompanyId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CompanyId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByTenantByTwoId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TenantId,
    Type: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TenantId=" +
      TenantId +
      "&Type=" +
      Type;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByCustomerId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomerID
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CustomerID=" +
      CustomerID;
    return this.http.get(url).map((response: Response) => response.json());
  }

  FileByCompanyIdAndUserIdV2(
    ControllerName: any,
    ActionName: any,
    userId,
    CompanyId,
    SelectedCompanyGSTCode,
    Data: any,
    Options: any
  ) {
    return this.anghttp
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?UserId=" +
        userId +
        "&CompanyId=" +
        CompanyId +
        "&SelectedCompanyGSTCode=" +
        SelectedCompanyGSTCode,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  FileByCompanyIdAndUserIdV3(
    ControllerName: any,
    ActionName: any,
    userId,
    CompanyId,
    SelectedCompanyGSTCode,
    OrderId: any,
    Data: any,
    Options: any
  ) {
    return this.anghttp
      .post(
        environment.apiUrl +
        "api/" +
        ControllerName +
        "/" +
        ActionName +
        "?UserId=" +
        userId +
        "&CompanyId=" +
        CompanyId +
        "&SelectedCompanyGSTCode=" +
        SelectedCompanyGSTCode +
        "&OrderId=" +
        OrderId,
        Data,
        Options
      )
      .map((response: Response) => {
        return response.text() != "" ? response.json() : null;
      });
  }

  GetByQueryPageByCustom(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomName: any,
    Param1: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&" +
      CustomName +
      "=" +
      Param1;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByTypeCompany(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    Type: any,
    CompanyId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&Type=" +
      Type +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByType(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    Type: any,
    CustomerId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&Type=" +
      Type +
      "&CustomerId=" +
      CustomerId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageByDeliveryCode(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomerId: any,
    DeliveryLocationCode: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CustomerId=" +
      CustomerId +
      "&DeliveryLocationCode=" +
      DeliveryLocationCode;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryByLocationCode(
    ControllerName: any,
    ActionName: any,
    query: any,
    CustomerId: any,
    PickupLocationCode: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&CustomerId=" +
      CustomerId +
      "&LocationCode=" +
      PickupLocationCode;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageVehicleNo(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TransporterId: any,
    VehicleTypeId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TransporterId=" +
      TransporterId +
      "&VehicleTypeId=" +
      VehicleTypeId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageCountry(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomerId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CustomerId=" +
      CustomerId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetByQueryPageCustomerCompany(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomerId,
    CompanyId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CustomerId=" +
      CustomerId +
      "&CompanyId=" +
      CompanyId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by vithu 22-02-2025
  getAuthToken() {
    if (this.cookieService.get("user_access_token")) {
      // if (localStorage.getItem('token') !== undefined) {
      let user_access_token = this.decryptpipe.transform(
        JSON.parse(this.cookieService.get("user_access_token"))
      );
      const token: string = "Bearer " + user_access_token;
      return token;
    }
  }

  //Added by fahim
  GetByQueryPageTranspoterId(ControllerName: any, ActionName: any, query: any, page: any, TranspoterId: any, Type: any, GetType: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TranspoterId=" +
      TranspoterId +
      "&Type=" +
      Type +
      "&GetType=" +
      GetType;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by vithu 26-03-2025
  GetQueryPagecharge(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    ChargeType: any,
    GSTType: any,
    TransporterId: any,
    THCId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&ChargeType=" +
      ChargeType +
      "&GSTType=" +
      GSTType +
      "&TransporterId=" +
      TransporterId +
      "&THCId=" +
      THCId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetQueryPagechargeRIncome(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TenantId: any,
    CompanyId: any,
    CustomerId: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&TenantId=" +
      TenantId +
      "&CompanyId=" +
      CompanyId +
      "&CustomerId=" +
      CustomerId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by vithu 28-08-2025 - Siddarth
  GetQueryPageLR(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CustomerId: any,
    CompanyId: any,
    InvoiceTypeId: any,
    InvoiceId: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CustomerId=" +
      CustomerId +
      "&CompanyId=" +
      CompanyId +
      "&InvoiceTypeId=" +
      InvoiceTypeId +
      "&InvoiceId=" +
      InvoiceId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  GetQueryPageChargeList(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    InvoiceTypeId: any,
    TenantId: any,
    CompanyId: any,
    GST: any) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&InvoiceTypeId=" +
      InvoiceTypeId +
      "&TenantId=" +
      TenantId +
      "&CompanyId=" +
      CompanyId +
      "&GST=" +
      GST;
    return this.http.get(url).map((response: Response) => response.json());
  }

  // Added by Burhan - 17/12/2025
  getAllIssues(): Observable<any> {
    return this.http.get(environment.apiUrl + '/api/issuetype');
  }
  // End by burhan

  // Added by priya - 16/12/2025
  UpdateSystemSettingByNameAndValue(ControllerName: any, ActionName: any, value: any, settingname: any) {
    let url = environment.apiUrl + "api/" + ControllerName +
      "/" + ActionName + "/?value=" + value + "&settingname=" + settingname;
    return this.http.get(url).map((response: Response) => response.json());
  }
  // end by priya

  //added by vithu 24-12-2025
  GetByQueryPageForReason(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    ReasonFor: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&ReasonFor=" +
      ReasonFor;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by fahim 25-12-2025
  GetByQueryPageAssignVehicle(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    CompanyId: any,
    TransporterId: any,
    VehicleId: any
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&CompanyId=" +
      CompanyId +
      "&TransporterId=" +
      TransporterId +
      "&VehicleId=" +
      VehicleId;
    return this.http.get(url).map((response: Response) => response.json());
  }

  //added by BURHAN - 13-April-2026
  GetByQueryPageBySelectedCustomerId(
    ControllerName: any,
    ActionName: any,
    query: any,
    page: any,
    TenantId
  ) {
    let url =
      environment.apiUrl +
      "api/" +
      ControllerName +
      "/" +
      ActionName +
      "?query=" +
      query +
      "&page=" +
      page +
      "&selectedCustomerId=" +
      TenantId;
    return this.http.get(url).map((response: Response) => response.json());
  }
  //added by BURHAN - 5-May-2026
  SetGST1ForCompany(data: any) {
    return this.http.post(`${environment.apiUrl}/api/Company/SetGST1ForCompany`, data);
  }

  so_gow_GetInvoiceDataForPrintBulk(payload: any) {
    return this.http.post(
      environment.apiUrl + "api/so_GoodsOutward/so_gow_GetInvoiceDataForPrint",
      payload
    ).map((response: Response) => response.json());
  }

  //end by BURHAN - 13-April-2026
}
